import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState, useCallback } from 'react';
import { ChevronUpOutlineIcon, ChevronDownOutlineIcon } from '@applyboard/ui-icons';
import { Box, Typography, StyledRawHtml, Button, Grid } from '@applyboard/ui-components';
import { CollapsibleCard } from "../Card";
import { useEntityRequirementTemplates } from "../../data/entityRequirementTemplates";
import { Container, Tag, Content } from "./style";
import { getDocumentRequirementsStages } from "./utils";
import { RequirementCondition } from "./RequirementCondition";
export var DocumentRequirementTemplates = function DocumentRequirementTemplates(_ref) {
  var program = _ref.program;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var onToggleReqPane = useCallback(function () {
    return setShow(!show);
  }, [show, setShow]);
  var _useEntityRequirement = useEntityRequirementTemplates({
      enable: show,
      filter: {
        entityType: 'program',
        entityIds: [program === null || program === void 0 ? void 0 : program.data.id].filter(function (s) {
          return !!s;
        })
      },
      include: ['condition', 'requirement_template', 'requirement_template.application_stage', 'requirement_template.document_requirement_templates']
    }),
    isLoadingEntityRequirementTemplates = _useEntityRequirement.isLoadingEntityRequirementTemplates,
    entityRequirementTemplates = _useEntityRequirement.entityRequirementTemplates;
  var stages = useMemo(function () {
    return getDocumentRequirementsStages(entityRequirementTemplates);
  }, [entityRequirementTemplates]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isLoadingEntityRequirementTemplates && show && stages && Object.values(stages).filter(function (stage) {
    return stage.requirements.length > 0;
  }).sort(function (s) {
    return s.position;
  }).map(function (stage) {
    return /*#__PURE__*/React.createElement(CollapsibleCard, {
      key: stage.id,
      header: "".concat(stage.label, " (").concat(stage.requirements.length, ")"),
      initialOpenState: true,
      fullWidth: true,
      nameForEventTracking: "Requirement Templates"
    }, stage.requirements.map(function (r) {
      return /*#__PURE__*/React.createElement(Container, {
        key: r.id,
        display: "flex",
        mb: 1,
        isRequired: !r.optional
      }, /*#__PURE__*/React.createElement(Tag, null, /*#__PURE__*/React.createElement(Box, {
        style: {
          transform: 'rotate(-90deg)',
          color: 'white'
        }
      }, r.optional ? 'Optional' : 'Required')), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, r.id, ": ", r.internalTitle, " [", r.requirementTemplateType, "]"), /*#__PURE__*/React.createElement(StyledRawHtml, {
        html: r.description
      }), r.condition && /*#__PURE__*/React.createElement(RequirementCondition, {
        condition: r.condition
      })));
    }));
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: onToggleReqPane,
    loading: isLoadingEntityRequirementTemplates,
    endIcon: show ? /*#__PURE__*/React.createElement(ChevronUpOutlineIcon, null) : /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null)
  }, !show || isLoadingEntityRequirementTemplates ? 'See Requirements' : 'Hide Requirements'))));
};